import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuard } from './guards/login.guard';
import { appRoutes as userRoutes } from './modules/app-routing.module';

export const Approutes: Routes = [
  {
    path: 'app',
    loadComponent: () => import('./layouts/layout.component').then(m => m.LayoutComponent),
    canActivate: [LoginGuard],
    children: userRoutes
  },
  {
    path: 'ecommerce',
    loadComponent: () => import('./layouts/ecommerce-layout.component').then(m => m.EcommerceLayoutComponent),
    canActivate: [LoginGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./ecommerce/components/dashboard/ecommerce-dashboard.component').then(m => m.EcommerceDashboardComponent)
      },
      {
        path: 'products/list',
        loadComponent: () => import('./ecommerce/components/ecommerce-products-list/ecommerce-products-list.component').then(m => m.EcommerceProductsListComponent)
      },
      {
        path: 'products/create',
        loadComponent: () => import('./ecommerce/components/ecommerce-product-create/ecommerce-product-create.component').then(m => m.EcommerceProductCreateComponent)
      },
      {
        path: 'products/colors',
        loadComponent: () => import('./ecommerce/components/ecommerce-colors-list/ecommerce-colors-list.component').then(m => m.EcommerceColorsListComponent)
      },
      {
        path: 'products/sizes',
        loadComponent: () => import('./ecommerce/components/ecommerce-sizes-list/ecommerce-sizes-list.component').then(m => m.EcommerceSizesListComponent)
      },
      {
        path: 'products/categories',
        loadComponent: () => import('./ecommerce/components/ecommerce-categories-list/ecommerce-categories-list.component').then(m => m.EcommerceCategoriesListComponent)
      },
      {
        path: 'products/brands',
        loadComponent: () => import('./ecommerce/components/ecommerce-brands-list/ecommerce-brands-list.component').then(m => m.EcommerceBrandsListComponent)
      },
      {
        path: 'products/styles',
        loadComponent: () => import('./ecommerce/components/ecommerce-styles-list/ecommerce-styles-list.component').then(m => m.EcommerceStylesListComponent)
      },
      {
        path: 'products',
        redirectTo: 'products/list',
        pathMatch: 'full'
      },
      {
        path: 'banners',
        loadComponent: () => import('./ecommerce/components/ecommerce-banners-list/ecommerce-banners-list.component').then(m => m.EcommerceBannersListComponent)
      },
          {
            path: 'newsletter',
            loadComponent: () => import('./ecommerce/components/ecommerce-newsletter-list/ecommerce-newsletter-list.component').then(m => m.EcommerceNewsletterListComponent)
          },
          {
            path: 'hero-slides',
            loadComponent: () => import('./ecommerce/components/ecommerce-hero-slides-list/ecommerce-hero-slides-list.component').then(m => m.EcommerceHeroSlidesListComponent)
          },
      {
        path: 'quotes/list',
        loadComponent: () => import('./ecommerce/components/ecommerce-quotes-list/ecommerce-quotes-list.component').then(m => m.EcommerceQuotesListComponent)
      },
      {
        path: 'quotes',
        redirectTo: 'quotes/list',
        pathMatch: 'full'
      },
      {
        path: 'customers/list',
        loadComponent: () => import('./ecommerce/components/ecommerce-clients-list/ecommerce-clients-list.component').then(m => m.EcommerceClientsListComponent)
      },
      {
        path: 'customers',
        redirectTo: 'customers/list',
        pathMatch: 'full'
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'app-selector',
    loadComponent: () => import('./components/app-selector/app-selector.component').then(m => m.AppSelectorComponent),
    canActivate: [LoginGuard]
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./resetPassword/resetPassword.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'facturar',
    loadComponent: () => import('./public-invoice/public-invoice.component').then(m => m.PublicInvoiceComponent)
  },
  {
    path: 'f/:token',
    loadComponent: () => import('./public-invoice/invoice-pdf-redirect.component').then(m => m.InvoicePdfRedirectComponent)
  },
  {
    path: 'o/:token',
    loadComponent: () => import('./public-invoice/order-pdf-redirect.component').then(m => m.OrderPdfRedirectComponent)
  },
  { path: '**', redirectTo: '/login' }
];
@NgModule({
  imports: [RouterModule.forRoot(Approutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
